
      import AliPay from './ali-pay.vue'
      import type { App, Plugin } from 'vue'

      export const AliPayPlugin: Plugin = {
        install(app: App) {
          app.component('AliPay', AliPay)
        },
      }
      export { AliPay }
      